import { ProblemDetails } from "../models/Http";
import { Discount, DiscountWriteModel } from "../models/Discount";
import { get, post, put } from "./api";
import { err, ok, Result } from "../result";
import { DiscountType } from "../views/discounts/types";

export const list = async (
  filterActive?: boolean,
  filterBuiltIn?: boolean
): Promise<Result<ProblemDetails, ReadonlyArray<Discount>>> => {
  const response = await get("/v1/discounts", { filterActive, filterBuiltIn });
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Discount>);
  }

  return err(content as ProblemDetails);
};

export const add = async (
  discount: DiscountWriteModel
): Promise<Result<ProblemDetails, Discount>> => {
  const response = await post("/v1/discounts", discount);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Discount);
  }

  return err(content as ProblemDetails);
};

export const update = async (
  discountId: string,
  discount: DiscountWriteModel
): Promise<Result<ProblemDetails, Discount>> => {
  const response = await put(`/v1/discounts/${discountId}`, discount);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Discount);
  }

  return err(content as ProblemDetails);
};

export const listTypes = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<DiscountType>>
> => {
  const response = await get("/v1/discounts/types");
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<DiscountType>);
  }
  return err(content as ProblemDetails);
};
